import React, {useState} from "react";
import OldCompanyShareSales from "./OldCompanyShareSales";
import NewCompanyShareSales from "./NewCompanyShareSales";
import BackButton from "../../../../../components/common/backbutton/BackButton";


const CompanyShareSalesPurches = () => {
 
  const [turnOn, setTurnOn] = useState(true)  


  return (
    <div className="px-10 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
          Company Share Sales Purchase Form
        </p>
        <div className="flex justify-between">
          <div className=" flex gap-2 text-primary-red my-4  flex-col md:flex-row text-base font-bold sm:text-lg">
            <div className="border-primary-blue font-Laila bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
              <input type="radio" name="radio-btn" id="old" 
              onChange={()=> setTurnOn(true)}
              />
            </div>
            <div className="border-primary-blue font-Laila bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" name="radio-btn" id="new" 
              onChange={()=> setTurnOn(false)}
              />
            </div>
          </div>
          <p className="text-primary-red flex items-center">
            Firm No.
            <span className=" text-primary-blue"> 1234</span>
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-primary-blue font-Calistoga text-lg underline my-3">
            1. Business Name & Other Details
          </p>
        </div>


      {
      turnOn ?  
      <OldCompanyShareSales/>
      :<NewCompanyShareSales/> 
      }

      
        {/* new company for 3 months */}
        
    </div>
  );
};

export default CompanyShareSalesPurches;
